$wj([21],{

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1744), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1751), exports);
tslib_1.__exportStar(__webpack_require__(1563), exports);
tslib_1.__exportStar(__webpack_require__(1564), exports);
tslib_1.__exportStar(__webpack_require__(671), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var DialogContent_types_1 = __webpack_require__(671);
var Button_1 = __webpack_require__(62);
var DialogFooter_1 = __webpack_require__(1564);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogContent = /** @class */ (function (_super) {
    tslib_1.__extends(DialogContent, _super);
    function DialogContent(props) {
        return _super.call(this, props) || this;
    }
    DialogContent.prototype.render = function () {
        var _a = this.props, showCloseButton = _a.showCloseButton, closeButtonAriaLabel = _a.closeButtonAriaLabel, onDismiss = _a.onDismiss, subTextId = _a.subTextId, subText = _a.subText, titleId = _a.titleId, title = _a.title, type = _a.type;
        var groupings = this._groupChildren();
        var subTextContent;
        if (subText) {
            subTextContent = React.createElement("p", { className: Utilities_1.css('ms-Dialog-subText', styles.subText), id: subTextId }, subText);
        }
        var contentClassName = Utilities_1.css(this.props.className, (_b = {},
            _b['ms-Dialog--lgHeader ' + styles.isLargeHeader] = type === DialogContent_types_1.DialogType.largeHeader,
            _b['ms-Dialog--close ' + styles.isClose] = type === DialogContent_types_1.DialogType.close,
            _b));
        return (React.createElement("div", { className: Utilities_1.css(contentClassName) },
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-header', styles.header) },
                React.createElement("p", { className: Utilities_1.css('ms-Dialog-title', styles.title), id: titleId, role: 'heading' }, title),
                React.createElement("div", { className: Utilities_1.css('ms-Dialog-topButton', styles.topButton) },
                    this.props.topButtonsProps.map(function (props) { return (React.createElement(Button_1.IconButton, tslib_1.__assign({}, props))); }),
                    (type === DialogContent_types_1.DialogType.close || (showCloseButton && type !== DialogContent_types_1.DialogType.largeHeader)) &&
                        React.createElement(Button_1.IconButton, { className: Utilities_1.css('ms-Dialog-button ms-Dialog-button--close', styles.button), iconProps: { iconName: 'Cancel' }, ariaLabel: closeButtonAriaLabel, onClick: onDismiss }))),
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-inner', styles.inner) },
                React.createElement("div", { className: Utilities_1.css('ms-Dialog-content', styles.content, this.props.className) },
                    subTextContent,
                    groupings.contents),
                groupings.footers)));
        var _b;
    };
    // @TODO - typing the footers as an array of DialogFooter is difficult because
    // casing "child as DialogFooter" causes a problem because
    // "Neither type 'ReactElement<any>' nor type 'DialogFooter' is assignable to the other."
    DialogContent.prototype._groupChildren = function () {
        var groupings = {
            footers: [],
            contents: []
        };
        React.Children.map(this.props.children, function (child) {
            if (typeof child === 'object' && child !== null && child.type === DialogFooter_1.DialogFooter) {
                groupings.footers.push(child);
            }
            else {
                groupings.contents.push(child);
            }
        });
        return groupings;
    };
    DialogContent.defaultProps = {
        showCloseButton: false,
        className: '',
        topButtonsProps: [],
        closeButtonAriaLabel: 'Close'
    };
    DialogContent = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], DialogContent);
    return DialogContent;
}(Utilities_1.BaseComponent));
exports.DialogContent = DialogContent;
//# sourceMappingURL=DialogContent.js.map

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogFooter = /** @class */ (function (_super) {
    tslib_1.__extends(DialogFooter, _super);
    function DialogFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFooter.prototype.render = function () {
        return (React.createElement("div", { className: Utilities_1.css('ms-Dialog-actions', styles.actions) },
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-actionsRight', styles.actionsRight) }, this._renderChildrenAsActions())));
    };
    DialogFooter.prototype._renderChildrenAsActions = function () {
        return React.Children.map(this.props.children, function (child) {
            return child && React.createElement("span", { className: Utilities_1.css('ms-Dialog-action', styles.action) }, child);
        });
    };
    return DialogFooter;
}(Utilities_1.BaseComponent));
exports.DialogFooter = DialogFooter;
//# sourceMappingURL=DialogFooter.js.map

/***/ }),

/***/ 1742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1562), exports);
var index_1 = __webpack_require__(1562);
exports.default = index_1.Dialog;
//# sourceMappingURL=Dialog.js.map

/***/ }),

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1560), exports);
var index_1 = __webpack_require__(1560);
exports.default = index_1.Modal;
//# sourceMappingURL=Modal.js.map

/***/ }),

/***/ 1744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var index_1 = __webpack_require__(674);
var Overlay_1 = __webpack_require__(675);
var Layer_1 = __webpack_require__(331);
var index_2 = __webpack_require__(599);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(1745);
var styles = stylesImport;
var Modal = /** @class */ (function (_super) {
    tslib_1.__extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            id: Utilities_1.getId('Modal'),
            isOpen: props.isOpen,
            isVisible: props.isOpen,
        };
        return _this;
    }
    Modal.prototype.componentWillReceiveProps = function (newProps) {
        clearTimeout(this._onModalCloseTimer);
        // Opening the dialog
        if (newProps.isOpen) {
            if (!this.state.isOpen) {
                // First Open
                this.setState({
                    isOpen: true
                });
            }
            else {
                // Reopen during closing
                this.setState({
                    isVisible: true
                });
            }
        }
        // Closing the dialog
        if (!newProps.isOpen && this.state.isOpen) {
            this._onModalCloseTimer = this._async.setTimeout(this._onModalClose, parseFloat(styles.duration) * 1000);
            this.setState({
                isVisible: false
            });
        }
    };
    Modal.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!prevProps.isOpen && !prevState.isVisible) {
            this.setState({
                isVisible: true
            });
        }
    };
    Modal.prototype.render = function () {
        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, onDismiss = _a.onDismiss, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, titleAriaId = _a.titleAriaId, subtitleAriaId = _a.subtitleAriaId;
        var _b = this.state, isOpen = _b.isOpen, isVisible = _b.isVisible;
        var modalClassName = Utilities_1.css('ms-Modal', styles.root, this.props.className, !!isOpen && 'is-open', !!isVisible && styles.rootIsVisible);
        if (!isOpen) {
            return null;
        }
        // @temp tuatology - Will adjust this to be a panel at certain breakpoints
        if (responsiveMode >= withResponsiveMode_1.ResponsiveMode.small) {
            return (React.createElement(Layer_1.Layer, { onLayerDidMount: onLayerDidMount },
                React.createElement(index_2.Popup, { role: isBlocking ? 'alertdialog' : 'dialog', ariaLabelledBy: titleAriaId, ariaDescribedBy: subtitleAriaId, onDismiss: onDismiss },
                    React.createElement("div", { className: modalClassName },
                        React.createElement(Overlay_1.Overlay, { isDarkThemed: isDarkOverlay, onClick: isBlocking ? undefined : onDismiss }),
                        React.createElement(index_1.FocusTrapZone, { componentRef: this._resolveRef('_focusTrapZone'), className: Utilities_1.css('ms-Dialog-main', styles.main, this.props.containerClassName), elementToFocusOnDismiss: elementToFocusOnDismiss, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap ? isClickableOutsideFocusTrap : !isBlocking, ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector }, this.props.children)))));
        }
        return null;
    };
    Modal.prototype.focus = function () {
        this._focusTrapZone && this._focusTrapZone.focus();
    };
    // Watch for completed animations and set the state
    Modal.prototype._onModalClose = function () {
        this.setState({
            isOpen: false
        });
        // Call the onDismiss callback
        if (this.props.onDismissed) {
            this.props.onDismissed();
        }
    };
    Modal.defaultProps = {
        isOpen: false,
        isDarkOverlay: true,
        isBlocking: false,
        className: '',
        containerClassName: '',
    };
    Modal = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], Modal);
    return Modal;
}(Utilities_1.BaseComponent));
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map

/***/ }),

/***/ 1745:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_561423dc{background-color:transparent;position:fixed;height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;opacity:0;pointer-events:none;-webkit-transition:opacity .267s;transition:opacity .267s}.root_561423dc .ms-Button.ms-Button--compound{display:block}[dir='ltr'] .root_561423dc .ms-Button.ms-Button--compound{margin-left:0}[dir='rtl'] .root_561423dc .ms-Button.ms-Button--compound{margin-right:0}@media screen and (-ms-high-contrast: active){.root_561423dc .ms-Overlay{opacity:0}}.rootIsVisible_561423dc{opacity:1;pointer-events:auto}.main_561423dc{background-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;outline:3px solid transparent;max-height:100%;overflow-y:auto}[dir='ltr'] .main_561423dc{-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,0.4);box-shadow:0 0 5px 0 rgba(0,0,0,0.4)}[dir='rtl'] .main_561423dc{-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,0.4);box-shadow:0 0 5px 0 rgba(0,0,0,0.4)}[dir='ltr'] .main_561423dc{text-align:left}[dir='rtl'] .main_561423dc{text-align:right}\n" }]);
exports.duration = ".267s";
exports.root = "root_561423dc";
exports.rootIsVisible = "rootIsVisible_561423dc";
exports.main = "main_561423dc";
//# sourceMappingURL=Modal.scss.js.map

/***/ }),

/***/ 1751:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var DialogContent_types_1 = __webpack_require__(671);
var Modal_1 = __webpack_require__(1743);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogContent_1 = __webpack_require__(1563);
var Dialog = /** @class */ (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this._getSubTextId = function () {
            var _a = _this.props, ariaDescribedById = _a.ariaDescribedById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, subText = _a.subText;
            var id = ariaDescribedById || (modalProps && modalProps.subtitleAriaId);
            if (!id) {
                id = (subText || (dialogContentProps && dialogContentProps.subText)) && _this._defaultSubTextId;
            }
            return id;
        };
        _this._getTitleTextId = function () {
            var _a = _this.props, ariaLabelledById = _a.ariaLabelledById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, title = _a.title;
            var id = ariaLabelledById || (modalProps && modalProps.titleAriaId);
            if (!id) {
                id = (title || (dialogContentProps && dialogContentProps.title)) && _this._defaultTitleTextId;
            }
            return id;
        };
        _this._id = Utilities_1.getId('Dialog');
        _this._defaultTitleTextId = _this._id + '-title';
        _this._defaultSubTextId = _this._id + '-subText';
        _this._warnDeprecations({
            'isOpen': 'hidden',
            'type': 'dialogContentProps.type',
            'subText': 'dialogContentProps.subText',
            'contentClassName': 'dialogContentProps.className',
            'topButtonsProps': 'dialogContentProps.topButtonsProps',
            'className': 'modalProps.className',
            'isDarkOverlay': 'modalProps.isDarkOverlay',
            'isBlocking': 'modalProps.isBlocking',
            'containerClassName': 'modalProps.containerClassName',
            'onDismissed': 'modalProps.onDismissed',
            'onLayerDidMount': 'modalProps.onLayerDidMount',
            'ariaDescribedById': 'modalProps.subtitleAriaId',
            'ariaLabelledById': 'modalProps.titleAriaId'
        });
        return _this;
    }
    Dialog.prototype.render = function () {
        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, isOpen = _a.isOpen, className = _a.className, onDismiss = _a.onDismiss, onDismissed = _a.onDismissed, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, subText = _a.subText, title = _a.title, type = _a.type, contentClassName = _a.contentClassName, topButtonsProps = _a.topButtonsProps, dialogContentProps = _a.dialogContentProps, modalProps = _a.modalProps, containerClassName = _a.containerClassName, hidden = _a.hidden;
        return (React.createElement(Modal_1.Modal, tslib_1.__assign({ elementToFocusOnDismiss: elementToFocusOnDismiss, firstFocusableSelector: firstFocusableSelector, forceFocusInsideTrap: forceFocusInsideTrap, ignoreExternalFocusing: ignoreExternalFocusing, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap, onDismissed: onDismissed, onLayerDidMount: onLayerDidMount, responsiveMode: responsiveMode }, modalProps, { isDarkOverlay: isDarkOverlay !== undefined ? isDarkOverlay : modalProps.isDarkOverlay, isBlocking: isBlocking !== undefined ? isBlocking : modalProps.isBlocking, isOpen: isOpen !== undefined ? isOpen : !hidden, className: Utilities_1.css('ms-Dialog', className ? className : modalProps.className), containerClassName: Utilities_1.css(styles.main, containerClassName ? containerClassName : modalProps.containerClassName), onDismiss: onDismiss ? onDismiss : modalProps.onDismiss, subtitleAriaId: this._getSubTextId(), titleAriaId: this._getTitleTextId() }),
            React.createElement(DialogContent_1.DialogContent, tslib_1.__assign({ titleId: this._defaultTitleTextId, subTextId: this._defaultSubTextId, title: title, subText: subText, showCloseButton: isBlocking !== undefined ? !isBlocking : !modalProps.isBlocking, topButtonsProps: topButtonsProps ? topButtonsProps : dialogContentProps.topButtonsProps, type: type !== undefined ? type : dialogContentProps.type, onDismiss: onDismiss ? onDismiss : dialogContentProps.onDismiss, className: Utilities_1.css(contentClassName ? contentClassName : dialogContentProps.className) }, dialogContentProps), this.props.children)));
    };
    Dialog.defaultProps = {
        modalProps: {
            isDarkOverlay: true,
            isBlocking: false,
            className: '',
            containerClassName: ''
        },
        dialogContentProps: {
            type: DialogContent_types_1.DialogType.normal,
            className: '',
            topButtonsProps: [],
        },
        hidden: true,
    };
    Dialog = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], Dialog);
    return Dialog;
}(Utilities_1.BaseComponent));
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map

/***/ }),

/***/ 1877:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var confirm_1 = __webpack_require__(3975);
exports.confirmAction = confirm_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 3975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ConfirmDialog_1 = __webpack_require__(3976);
var DialogResponse;
(function (DialogResponse) {
    DialogResponse[DialogResponse["ok"] = 0] = "ok";
    DialogResponse[DialogResponse["cancel"] = 1] = "cancel";
    DialogResponse[DialogResponse["dismiss"] = 2] = "dismiss";
})(DialogResponse = exports.DialogResponse || (exports.DialogResponse = {}));
function confirm(title, subText, resolveImmediately, customizationOptions) {
    if (resolveImmediately) {
        // This is useful in cases where the user wants to display the
        // dialog only if a certain condition is met. It will allow
        // to keep the code simple for who uses it.
        return Promise.resolve(0 /* ok */);
    }
    return new Promise(function (resolve, reject) {
        ConfirmDialog_1.default(title, subText, customizationOptions, function () {
            resolve(0 /* ok */);
        }, function () {
            resolve(1 /* cancel */);
        }, function () {
            resolve(2 /* dismiss */);
        });
    });
}
exports.default = confirm;
//# sourceMappingURL=confirm.js.map

/***/ }),

/***/ 3976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Button_1 = __webpack_require__(62);
var Dialog_1 = __webpack_require__(1742);
var owa_common_strings_1 = __webpack_require__(37);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var styles = __webpack_require__(3977);
var ConfirmDialog = /** @class */ (function (_super) {
    tslib_1.__extends(ConfirmDialog, _super);
    function ConfirmDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.setInitialFocus = function () {
            if (_this.cancel && _this.props.customizationOptions.focusOnCancel) {
                _this.cancel.focus();
            }
            else if (_this.props.customizationOptions.focusCallback) {
                _this.props.customizationOptions.focusCallback();
            }
            else if (_this.ok) {
                // if no custom focus is implemented, autofocus on "OK"
                _this.ok.focus();
            }
        };
        _this.onClick = function (callback) {
            if (callback) {
                if (_this.props.customizationOptions &&
                    _this.props.customizationOptions.delayCallbackAfterAnimation) {
                    _this.delayedCallback = callback;
                }
                else {
                    callback();
                }
            }
            _this.setState({
                isShown: false,
            });
        };
        _this.onDismiss = function () {
            if (_this.props.onDismissCallback) {
                // We dismissed without issuing a callback.
                // Call 'cancel'
                _this.props.onDismissCallback();
            }
            if (!_this.props.customizationOptions.preventSoftDismiss) {
                _this.setState({
                    isShown: false,
                });
            }
        };
        _this.onDismissed = function () {
            if (_this.delayedCallback) {
                _this.delayedCallback();
                _this.delayedCallback = null;
            }
            _this.props.onClose();
        };
        _this.state = {
            isShown: true,
        };
        return _this;
    }
    ConfirmDialog.prototype.render = function () {
        var _this = this;
        var customizationOptions = this.props.customizationOptions;
        var onOk = function () { return _this.onClick(_this.props.onOkCallback); };
        var onCancel = function () { return _this.onClick(_this.props.onCancelCallback); };
        return (React.createElement(Dialog_1.Dialog, { isOpen: this.state.isShown, type: Dialog_1.DialogType.normal, onDismiss: this.onDismiss, onDismissed: this.onDismissed, subText: this.props.subText, title: this.props.title, containerClassName: customizationOptions.containerClassName, contentClassName: styles.content, modalProps: {
                onLayerDidMount: this.setInitialFocus,
            } },
            React.createElement("form", { onSubmit: function (evt) {
                    evt.preventDefault();
                    onOk();
                } }, customizationOptions.bodyElement),
            React.createElement(Dialog_1.DialogFooter, null,
                React.createElement(Button_1.Button, { componentRef: function (buttonRef) {
                        _this.ok = buttonRef;
                    }, buttonType: Button_1.ButtonType.primary, onClick: onOk, title: customizationOptions.okToolTip }, customizationOptions.okText || owa_common_strings_1.default.okButton),
                customizationOptions.hideCancelButton ? null : (React.createElement(Button_1.Button, { componentRef: function (buttonRef) {
                        _this.cancel = buttonRef;
                    }, buttonType: Button_1.ButtonType.normal, onClick: onCancel, title: customizationOptions.cancelToolTip }, customizationOptions.cancelText || owa_common_strings_1.default.cancelButton)))));
    };
    ConfirmDialog.defaultProps = {
        customizationOptions: {},
    };
    return ConfirmDialog;
}(React.Component));
var instance = 0;
function showConfirmDialog(title, subText, customizationOptions, onOkCallback, onCancelCallback, onDismissCallback) {
    // Initialize it and append it to the body.
    var confirmDialogDiv = document.createElement('div');
    confirmDialogDiv.id = "confirmDialog" + instance++;
    document.body.appendChild(confirmDialogDiv);
    ReactDOM.render(React.createElement(ConfirmDialog, { title: title, subText: subText, customizationOptions: customizationOptions, onOkCallback: onOkCallback, onCancelCallback: onCancelCallback, onDismissCallback: onDismissCallback, onClose: function () {
            ReactDOM.unmountComponentAtNode(confirmDialogDiv);
            document.body.removeChild(confirmDialogDiv);
        } }), confirmDialogDiv);
}
exports.default = showConfirmDialog;
//# sourceMappingURL=ConfirmDialog.js.map

/***/ }),

/***/ 3977:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3978);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3978:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".VHdW41_pzN_kcH6PttbMk{max-height:80%;overflow:auto}", ""]);

// exports
exports.locals = {
	"content": "VHdW41_pzN_kcH6PttbMk"
};

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DialogType;
(function (DialogType) {
    /** Standard dialog */
    DialogType[DialogType["normal"] = 0] = "normal";
    /** Dialog with large header banner */
    DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
    /** Dialog with an 'x' close button in the upper-right corner */
    DialogType[DialogType["close"] = 2] = "close";
})(DialogType = exports.DialogType || (exports.DialogType = {}));
//# sourceMappingURL=DialogContent.types.js.map

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".isOpen_a6c8430f{display:-webkit-box;display:-ms-flexbox;display:flex}.main_a6c8430f{width:288px}.button_a6c8430f.isClose_a6c8430f .ms-Icon.ms-Icon--Cancel{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";font-size:16px}.inner_a6c8430f{padding:0 28px 20px}.header_a6c8430f{position:relative;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.title_a6c8430f{margin:0;font-size:21px;font-weight:100;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";padding:20px 36px 20px 28px}[dir='rtl'] .title_a6c8430f{padding:20px 28px 20px 36px}.topButton_a6c8430f{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;position:absolute;top:0;padding:12px 12px 0 0}[dir='ltr'] .topButton_a6c8430f{right:0}[dir='rtl'] .topButton_a6c8430f{left:0}[dir='rtl'] .topButton_a6c8430f{padding:12px 0 0 12px}.topButton_a6c8430f>*{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.content_a6c8430f{position:relative;width:100%}.content_a6c8430f .ms-Button.ms-Button--compound{margin-bottom:20px}.content_a6c8430f .ms-Button.ms-Button--compound:last-child{margin-bottom:0}.subText_a6c8430f{margin:0 0 20px 0;padding-top:8px;font-size:12px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:300;line-height:1.5;word-wrap:break-word}.actions_a6c8430f{position:relative;width:100%;min-height:24px;line-height:24px;margin:20px 0 0;font-size:0}.actions_a6c8430f .ms-Button{line-height:normal}.actionsRight_a6c8430f{font-size:0}[dir='ltr'] .actionsRight_a6c8430f{text-align:right}[dir='rtl'] .actionsRight_a6c8430f{text-align:left}[dir='ltr'] .actionsRight_a6c8430f{margin-right:-4px}[dir='rtl'] .actionsRight_a6c8430f{margin-left:-4px}.actionsRight_a6c8430f .action_a6c8430f{margin:0px 4px}.isMultiline_a6c8430f .title_a6c8430f{font-size:28px}.isMultiline_a6c8430f .inner_a6c8430f{padding:0 20px 20px}.isLargeHeader_a6c8430f .header_a6c8430f{background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.isLargeHeader_a6c8430f .title_a6c8430f{font-size:28px;font-weight:100;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";padding:26px 28px 28px;margin-bottom:8px}.isLargeHeader_a6c8430f .subText_a6c8430f{font-size:14px}@media (min-width: 480px){.main_a6c8430f{width:auto;min-width:288px;max-width:340px}}\n" }]);
exports.isOpen = "isOpen_a6c8430f";
exports.main = "main_a6c8430f";
exports.button = "button_a6c8430f";
exports.isClose = "isClose_a6c8430f";
exports.inner = "inner_a6c8430f";
exports.header = "header_a6c8430f";
exports.title = "title_a6c8430f";
exports.topButton = "topButton_a6c8430f";
exports.content = "content_a6c8430f";
exports.subText = "subText_a6c8430f";
exports.actions = "actions_a6c8430f";
exports.actionsRight = "actionsRight_a6c8430f";
exports.action = "action_a6c8430f";
exports.isMultiline = "isMultiline_a6c8430f";
exports.isLargeHeader = "isLargeHeader_a6c8430f";
//# sourceMappingURL=Dialog.scss.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.ConfirmDialog.js